import http from './httpService';
import config from './../config.json';

const address = config.api_address + config.api_area;

export const getAllArea = ({signal}) => {
    return http.get(`${address}/get-archive`, {signal});
}

export const createArea = (info) => {
    return http.post(`${address}/create-area`, info);
}

export const updateArea = (_id, info) => {
    return http.patch(`${address}/update-area/${_id}`, info);
}

export const deleteAreaById = (_id) => {
    return http.delete(`${address}/delete-area/${_id}`);

}
